import React, { useEffect } from "react";
import { Box, Stack, TextField, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { useQuery } from "@apollo/client";
import { useState } from "react";
import { GET_INCOME_BY_INCOME_TYPE } from "../../Schema/Dashboard";
import { currencyFormat } from "../../Function/DynamicFn";

import { useNavigate } from "react-router-dom";

import LoadingPage from "../Include/LoadingPage";

//Date
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

export default function IncomeByIncomeTypeChart() {

  const navigate = useNavigate()

  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [date, setDate] = useState(moment());
  const [loading, setLoading] = useState(true)


  const { refetch } = useQuery(GET_INCOME_BY_INCOME_TYPE, {
    variables: {
      date: moment(date).format("YYYY-MM-DD")
    },
    onCompleted: ({ getIncomeByIncomeType }) => {
      setLoading(false)
      if (getIncomeByIncomeType) {
        setData(getIncomeByIncomeType?.map((e) => e?.totalAmount))
        setCategories(getIncomeByIncomeType?.map((e) => e?.incomeType))
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  })

  useEffect(() => {
    refetch();
  }, [date])

  let colors = [
    "#00C9C8",
    "#ED5E93",
    "#005B60",
    "#6D4B9A",
    "#009B49",
    "#B62A8F",
    "#0082FF",
    "#FFE237",
    "#281713",
    "#009700",
  ];
  const state = {
    series: [{ data: data }],
    options: {
      chart: {
        height: 350,
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      colors: colors,
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return `$ ${currencyFormat(val)}`;
          } else {
            return "0";
          }
        },
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: categories,
        labels: {
          trim: true,
          style: {
            colors: colors,
            fontSize: "12px",
            fontFamily: "Khmer OS Siemreap",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
        x: { show: false },
      },
    },
  };

  return (
    <>
      <Box className="employee-chart" sx={{ cursor: "pointer" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems={"center"}
        >
          <Typography className="chart-title" sx={{ color: "#0f81c2" }}>
            Income By Type {moment(date).format("DD-MM-YYYY")}
          </Typography>
          <Stack>
            <LocalizationProvider
              className="date-controll"
              dateAdapter={AdapterDateFns}
            >
              <DatePicker
                onChange={(e) => setDate(e)}
                // inputFormat="MM-yyyy"
                renderInput={(params) => (
                  <TextField
                    className="select-date"
                    size="small"
                    {...params}
                    type="date"
                    fullWidth
                  />
                )}
                value={date !== "" ? date : ""}
              />
            </LocalizationProvider>
          </Stack>
        </Stack>
        {
          loading ?
            <LoadingPage /> :
            <div id="chart"  onClick={() => navigate("/report/income-report")}>
              <ReactApexChart
                options={state.options}
                series={state.series}
                type="bar"
                height={330}
              />
            </div>
        }
      </Box>
    </>
  );
}
